import {TemplateStore, ModalsStore, UIStore, TranslationStore} from "@cmodules/checklist/assets/data/types"

class ChecklistStore {
  template: TemplateStore;
  multiSelectMode: boolean;
  ui: UIStore;
  translationMultiSelectMode: boolean;
  translation: TranslationStore;
  hidePages: boolean;
  modals: ModalsStore;
  testData?: any;

  constructor(
    template: TemplateStore = new TemplateStore(),
    multiSelectMode = false,
    ui: UIStore = new UIStore(),
    translationMultiSelectMode = false,
    translation: TranslationStore = new TranslationStore(),
    hidePages = false,
    modals: ModalsStore = new ModalsStore(),
    testData?: any
  ) {
    this.template = template
    this.multiSelectMode = multiSelectMode
    this.ui = ui
    this.translationMultiSelectMode = translationMultiSelectMode
    this.translation = translation
    this.hidePages = hidePages
    this.modals = modals
    this.testData = testData
  }
}
export {ChecklistStore}
